import React from "react";
import { ProductDetails, List } from "@dtpk-cc/components";

import "@dtpk-cc/components/dist/global.css";
import "@dtpk-cc/components/dist/components/ProductDetails/ProductDetails.css";
import "@dtpk-cc/components/dist/components/List/List.css";


export default function TariffDetails({tariff}){

  const formatPrice = (price) => {
    return String(price).replace('.', ',');
  }

  return (
    <ProductDetails>
      <ProductDetails.Heading tag="h2">Tarifdetails</ProductDetails.Heading>

      <ProductDetails.ListSection>
        <ProductDetails.Item>
          <ProductDetails.Label>Grundpreis</ProductDetails.Label>
          <ProductDetails.List>
            <List>
              <List.Item>
                <List.Text>
                  Monatlich {tariff.price.discountValue ? formatPrice(tariff.price.discountValue) : formatPrice(tariff.price.defaultValue)} &euro;
                </List.Text>
              </List.Item>

              {tariff.price.discountValue && <List.Item>
                <List.Text>
                  Ab dem {tariff.price.discountDuration+1}. Monat {formatPrice(tariff.price.defaultValue)} &euro;
                </List.Text>
              </List.Item>}
            </List>
          </ProductDetails.List>
        </ProductDetails.Item>

        <ProductDetails.Item>
          <ProductDetails.Label>Bereitstellungspreis</ProductDetails.Label>
          <ProductDetails.List>
            <List>
              <List.Item>
                <List.Text>
                  Einmalig 0 &euro;
                </List.Text>
              </List.Item>
            </List>
          </ProductDetails.List>
        </ProductDetails.Item>

        <ProductDetails.Item>
          <ProductDetails.Label>Mindestlaufzeit</ProductDetails.Label>
          <ProductDetails.List>
            <List>
              <List.Item>
                <List.Text>
                  24 Monate
                </List.Text>
              </List.Item>
            </List>
          </ProductDetails.List>
        </ProductDetails.Item>

        <ProductDetails.Item>
          <ProductDetails.Label>Telefonie</ProductDetails.Label>
          <ProductDetails.List>
            <List>
              <List.Item>
                <List.Text>
                  Flatrate ins dt. Festnetz: inklusive
                </List.Text>
              </List.Item>

              {tariff.tariffDetails.telephony.germanyMobile === 'inklusive' &&<List.Item>
                <List.Text>
                  Flatrate in alle deutschen Mobilfunknetze: inklusive
                </List.Text>
              </List.Item>}

              {tariff.tariffDetails.telephony.germanyMobile !== 'inklusive' && <List.Item>
                <List.Text>
                  Telefonieren ins dt. Mobilfunknetz: {tariff.tariffDetails.telephony.germanyMobile}
                </List.Text>
              </List.Item>}

              <List.Item>
                <List.Text>
                  Telefonieren ins Ausland: Ab 2,9 Cent/Minute
                </List.Text>
              </List.Item>
            </List>
          </ProductDetails.List>
        </ProductDetails.Item>

        <ProductDetails.Item>
          <ProductDetails.Label>Internet</ProductDetails.Label>
          <ProductDetails.List>
            <List>
              <List.Item>
                <List.Text>
                  Geschwindigkeit Download: bis zu {tariff.maxDownload} MBit/s
                </List.Text>
              </List.Item>

              <List.Item>
                <List.Text>
                  Geschwindigkeit Upload: bis zu {tariff.maxUpload} MBit/s
                </List.Text>
              </List.Item>
            </List>
          </ProductDetails.List>
        </ProductDetails.Item>

        <ProductDetails.Item>
          <ProductDetails.Label>Weitere Inklusivleistungen</ProductDetails.Label>
          <ProductDetails.List>
            <List>
              <List.Item>
                <List.Text>
                  E-Mail Postfach: 1 GB Speicherplatz mit Spam- und Virenschutz
                </List.Text>
              </List.Item>

              <List.Item>
                <List.Text>
                  MagentaCLOUD: 15 GB Online-Speicher
                </List.Text>
              </List.Item>
              
              <List.Item>
                <List.Text>
                  RechnungOnline: jeden Monat Rechnung per E-Mail erhalten
                </List.Text>
              </List.Item>
              
              <List.Item>
                <List.Text>
                  Vor-Ort-Service: innerhalb 24 h
                </List.Text>
              </List.Item>
            </List>
          </ProductDetails.List>
        </ProductDetails.Item>
      </ProductDetails.ListSection>
    </ProductDetails>
  );

}